<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :block="$vuetify.breakpoint.smAndDown"
        color="success"
        v-on="on"
      >
        Create Position Group
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Position Group"
      text="Create Position Group"
      class="mb-0"
    >
      <form>
        <v-container v-if="dialog">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
          
            <v-col cols="12">
              <v-autocomplete
                v-model="positionCategory"
                v-validate="'required'"
                :error-messages="errors.collect('positionCategory')"
                :items="positionCategories"
                data-vv-name="positionCategory"
                data-vv-as="position category"
                item-text="name"
                multiple
                chips
                hide-selected
                hide-no-data
                deletable-chips
                item-value="id"
                label="Position Categories"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="leaveEntitlementSetting"
                v-validate="'required'"
                :error-messages="errors.collect('leaveEntitlementSetting')"
                :items="leaveEntitlementSettings"
                data-vv-name="leaveEntitlementSetting"
                data-vv-as="leave entitlement"
                item-text="name"
                item-value="id"
                multiple
                chips
                hide-selected
                hide-no-data
                deletable-chips
                label="Leave Entitlement"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        progressing: false,
        dialog: false,
        positionCategory: null,
        name: null,
        positionCategories: [],
        leaveEntitlementSettings: [],
        leaveEntitlementSetting: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadPositionCategories()
          this.loadLeaveEntitlementSettings()
        } else {
          this.$resetData()
        }
      },
    },
    methods: {     
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
          
            this.progressing = true
            
            this.$api.positionGroups().create({ name: this.name, positionCategories: this.positionCategory, leaveEntitlementSettings: this.leaveEntitlementSetting })
              .then(res => {
                this.progressing = false

                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.dialog = false
              })
          })
      },

      loadPositionCategories () {
        this.$api.positionCategories().list()
          .then(res => {
            this.positionCategories = res.data
          })
      },

      loadLeaveEntitlementSettings () {
        this.$api.leaveEntitlementSettings().list()
          .then(res => {
            this.leaveEntitlementSettings = res.data
          })
      },
    },
  }
</script>
